// extracted by mini-css-extract-plugin
export default {"pointsUntilNextLevel":"PointsUntilNextLevel_pointsUntilNextLevel__H1yVE"};